module.exports = __webpack_public_path__ + "static/media/phone-1.4cd86a97.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/phone-1.jpg
 ** module id = 257
 ** module chunks = 0
 **/